import { useEffect, useState } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { toastActions, TOAST_STATUS } from '@leagueplatform/toast-messages';
import {
  usePersonalInformation,
  useUpdateUserProfile,
} from '../use-personal-information/use-personal-information.hook';

export const useCommunicationPreferences = () => {
  const { formatMessage } = useIntl();
  const updateUserProfile = useUpdateUserProfile();
  const {
    data: personalInformation,
    isLoading,
    error,
  } = usePersonalInformation();

  const optedIntoMarketingCommunications =
    !!personalInformation?.userProfile?.optedIntoMarketingCommunications;

  const [isEmailNotificationEnabled, setIsEmailNotificationEnabled] =
    useState<boolean>(false);

  const [isCurrentlyUpdating, setIsCurrentlyUpdating] = useState(false);

  useEffect(() => {
    if (isLoading === false && personalInformation?.userProfile) {
      setIsEmailNotificationEnabled(optedIntoMarketingCommunications);
    }
  }, [
    isLoading,
    personalInformation?.userProfile,
    optedIntoMarketingCommunications,
  ]);

  const toggleEmailNotification = async () => {
    try {
      setIsEmailNotificationEnabled(!isEmailNotificationEnabled);
      setIsCurrentlyUpdating(true);
      await updateUserProfile({
        optedIntoMarketingCommunications: !isEmailNotificationEnabled,
      });
      toastActions.add({
        type: TOAST_STATUS.SUCCESS,
        textId: formatMessage({
          id: 'STR_EMAIL_NOTIFICATION_PREFERENCE_SUCCESS',
        }),
      });
    } catch (err) {
      // Set value back to original state retrieved from usePersonalInformation
      setIsEmailNotificationEnabled(optedIntoMarketingCommunications);
      toastActions.add({
        type: TOAST_STATUS.ERROR,
        textId: formatMessage({
          id: 'STR_EMAIL_NOTIFICATION_PREFERENCE_ERROR',
        }),
      });
    }
    setIsCurrentlyUpdating(false);
  };
  return {
    toggleEmailNotification,
    isEmailNotificationEnabled,
    isLoading,
    error,
    isCurrentlyUpdating,
    email: personalInformation?.email,
    showEmail: isEmailNotificationEnabled,
  };
};
